import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/LoginForm';

const Login: React.FC = () => {
  const navigate = useNavigate();
  return <LoginForm onLoginSuccess={() => navigate('/')}/>;
};

export default Login;
